import { API_ENDPOINTS } from "../config/config";
import apiClient, { apiRequest } from "./apiClient";

/**
 * User Service
 * Handles all user-related API calls
 */

/**
 * Fetch Users List
 * @param {Object} params - Query parameters
 *   - limit: integer (minimum: 1, maximum: 200) - Number of items to return
 *   - offset: integer (minimum: 0) - Pagination offset
 *   - is_active: boolean - Filter by active status
 *   - q: string - Search by name or email
 * @returns {Promise<{success: boolean, data?: Array, message?: string}>}
 */
export const getUsers = async (params = {}) => {
  return apiRequest(
    () => apiClient.get(API_ENDPOINTS.USERS, { params }),
    "Failed to fetch users"
  );
};

/**
 * Create a new user
 * @param {Object} userData - User data
 *   - first_name: string (required)
 *   - last_name: string (required)
 *   - email: string (required)
 *   - role: string (required) - e.g., "admin", "viewer", "user"
 *   - auth_type: string (required) - "password" or "sso"
 *   - password: string (required if auth_type is "password")
 *   - sso_provider: string (optional) - e.g., "google", "microsoft"
 *   - is_active: boolean (optional) - defaults to true
 * @returns {Promise<{success: boolean, data?: Object, message?: string}>}
 */
export const createUser = async (userData) => {
  return apiRequest(
    () => apiClient.post(API_ENDPOINTS.USERS, userData),
    "Failed to create user"
  );
};
